export default "__VITE_ASSET__817aeb8c__"